import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Events } from 'ionic-angular';
import { Storage } from '@ionic/storage';
import { GlobalVariable } from '../global';

@Injectable()
export class UserData {
  private apiUrl = GlobalVariable.BASE_API_URL; //get api url
  _favorites: string[] = [];
  HAS_LOGGED_IN = 'hasLoggedIn';
  HAS_SEEN_TUTORIAL = 'hasSeenTutorial';
  isLoggedIn: boolean = false;
  userid: number;
  constructor(
    public events: Events,
    public storage: Storage,
    public http: HttpClient
  ) {
    this.setUserID();
  }

  hasFavorite(sessionName: string): boolean {
    return (this._favorites.indexOf(sessionName) > -1);
  };

  addFavorite(sessionName: string): void {
    this._favorites.push(sessionName);
  };

  removeFavorite(sessionName: string): void {
    let index = this._favorites.indexOf(sessionName);
    if (index > -1) {
      this._favorites.splice(index, 1);
    }
  };

  login(formData) {
    return this.http.post(this.apiUrl + 'user/authenticate', formData).map((res) => {
      if (res['success']) {
        this.isLoggedIn = true
        this.storage.set(this.HAS_LOGGED_IN, true);
        this.userid = res['data']['userId'];
        this.storage.set('userId', res['data']['userId']);
        this.storage.set('auth_token', res['data']['token']);
        this.storage.set('username', res['data']['username']);
        this.storage.set('usertype', res['data']['userType']);
        this.storage.set('organisationId', res['data']['organisationId']);
        this.storage.set('ismentor', res['data']['isMentor']);
        this.storage.set('changepassword', res['data']['changepassword']);
        this.events.publish('user:login', res['data']['userType'], res['data']['username'], res['data']['isMentor']);
        return res['data']
      } else {
        return false;
      }
    })
  };

  signup(username: string): void {
    this.storage.set(this.HAS_LOGGED_IN, true);
    this.setUsername(username);
    this.events.publish('user:signup');
  };

  logout(): void {
    this.isLoggedIn = false
    this.storage.remove(this.HAS_LOGGED_IN);
    this.storage.remove('userId');
    this.storage.remove('username');
    this.storage.remove('usertype');
    this.storage.remove('auth_token');
    this.storage.remove('organisationId');
    this.events.publish('user:logout');
  };

  setUsername(username: string): void {
    this.storage.set('username', username);
  };

  setUserID() {
    this.storage.get('userId').then(val => {
      this.userid = val;
    })
  }

  get getuserid() {
    return this.userid;
  }

  getUsername(): Promise<string> {
    return this.storage.get('username').then((value) => {
      return value;
    });
  };

  getUserType(): Promise<string> {
    return this.storage.get('usertype').then((value) => {
      return value;
    });
  };

  hasLoggedIn(): Promise<boolean> {
    return this.storage.get(this.HAS_LOGGED_IN).then((value) => {
      return value;
    });
  };

  checkHasSeenTutorial(): Promise<string> {
    return this.storage.get(this.HAS_SEEN_TUTORIAL).then((value) => {
      return value;
    });
  };

  authenticated(): boolean {
    return this.isLoggedIn;
  }

  saveUser(formData) {
    return this.http.post(this.apiUrl + 'user/user', formData)
  }

  getUserListByOrganisationId() {
    return this.http.get(this.apiUrl + 'user-by-organisaionid')
  }

  changePassword(formData) {
    return this.http.put(this.apiUrl + 'change-password', formData)
  }

  getUserByUserId(userid) {
    return this.http.get(this.apiUrl + `user-by-userid?userid=${userid}`)
  }

  updateUser(formData) {
    return this.http.put(this.apiUrl + 'user/user', formData)
  }

  forgetPassword(formData) {
    return this.http.post(this.apiUrl + 'user/forgot-password', formData)
  }

  checkPasswordToken(token) {
    return this.http.get(this.apiUrl + `user/check-password-token?token=${token}`)
  }

  changeForgetPassword(formData) {
    return this.http.post(this.apiUrl + 'user/change-forgot-password', formData)
  }

  checkAuth() {
    return this.http.get(this.apiUrl + `user/check-auth`);
  }

  getNotifications(isseen = undefined) {
    if (isseen) {
      return this.http.get(this.apiUrl + `user/notifications?isseen=${isseen}`);
    } else {
      return this.http.get(this.apiUrl + `user/notifications`);
    }
  }
}



// WEBPACK FOOTER //
// ./src/providers/user-data.ts